import axios from "axios";

import { API_ORIGIN } from "./apiConfig";

const API_BASE_URL = `${API_ORIGIN}/usp`;

// Common auth header function
const getAuthHeaders = () => {
    const token = localStorage.getItem("admin_access_token");
    return {
        "Content-Type": "application/json",
        Accept: "application/json",
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
    };
};

// ------------------------------
// ENQUIRIES APIs
// ------------------------------

// POST enquiry (for Contact form)
export const createEnquiry = async (data) => {
    try {
        const response = await axios.post(`${API_BASE_URL}/enquiries`, data, {
            headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
            },
        });
        return response.data;
    } catch (error) {
        console.error("Error creating enquiry:", error);
        throw error.response?.data || { message: "Something went wrong" };
    }
};

// GET all enquiries (admin)
export const getAllEnquiries = async () => {
    try {
        const response = await axios.get(`${API_BASE_URL}/admin/enquiries`, {
            headers: getAuthHeaders(),
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching enquiries:", error);
        throw error.response?.data || { message: "Something went wrong" };
    }
};

// GET enquiry by ID
export const getEnquiryById = async (id) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/admin/enquiries/${id}`, {
            headers: getAuthHeaders(),
        });
        return response.data;
    } catch (error) {
        console.error(`Error fetching enquiry ${id}:`, error);
        throw error.response?.data || { message: "Something went wrong" };
    }
};

// GET enquiries by status
export const getEnquiriesByStatus = async (status) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/admin/enquiries/status/${status}`, {
            headers: getAuthHeaders(),
        });
        return response.data;
    } catch (error) {
        console.error(`Error fetching enquiries by status ${status}:`, error);
        throw error.response?.data || { message: "Something went wrong" };
    }
};

// UPDATE enquiry (status, notes, etc.)
export const updateEnquiry = async (id, data) => {
    try {
        const response = await axios.put(`${API_BASE_URL}/admin/enquiries/${id}`, data, {
            headers: getAuthHeaders(),
        });
        return response.data;
    } catch (error) {
        console.error(`Error updating enquiry ${id}:`, error);
        throw error.response?.data || { message: "Something went wrong" };
    }
};
